import { handleSubmit } from '../components/ProgressiveFormStepper/utils';

export const exitToMenu = (props) => {
  handleSubmit(props, 'menu', 'section');
};